<template>
  <div class='text-center'>
      <div class='bigDiv'>
        <div>Contacto</div>
        <div>alanautos.com</div>
      </div>
      <hr>
        <img v-bind:src="$http.options.root + '/images/alanpicture.jpg'" class="img-circle" alt="AlanAutos">        
      <hr>
      <div class='normalDiv'>
        <div>Propietario: Alan Rodriguez</div>
        <div>Telefono - Whatsapp: 849-525-0036</div>        
        <div>Santo Domingo</div>
        <div>República Dominicana</div>
      </div>
      <hr>
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {
  data: function () {
    return { }
  },
  mounted: function () {

  },
  methods: {

  },
  filters: {

  },
  computed: {

  }
}
</script>

<style scoped>
  .bigDiv{
    font-size: 3em;
    color: #2D80C7;
  }

  .normalDiv{
    font-size: 1.8em;
    color: #2D80C7;
  }

  @media screen and (max-width: 981px) {
    .bigDiv{
      font-size: 6em;
      color: #2D80C7;
    }

    .normalDiv{
      font-size: 4em;
      color: #2D80C7;
    }

    img { 
      height: 500px;
    } 
  }
</style>


// WEBPACK FOOTER //
// Contact.vue?772b77d8